module.exports = __webpack_public_path__ + "img/gemerbarbier_priceList.02fe9661.jpg";